export const RESET_REDUX = 'redux/RESET';
export const LOADER_SET = 'loader/SET';
export const NOTIFY_SET = 'notify/SET';
export const USER_SET = 'user/SET';
export const TICKER_SET = 'ticker/SET';
export const CPTY_SET = 'cpty/SET';
export const REFRESH_SET = 'refresh/SET';
export const REFRESH_LOAN = 'refreshloan/SET';
export const REFRESH_BORROW = 'refreshborrow/SET';
export const REFRESH_SECMASTER = 'refreshsecmaster/SET';
export const REFRESH_CPTY = 'refreshcpty/SET';


export const resetRedux = () => ({
  type: RESET_REDUX
});

export const loaderSet = (state) => ({
  type: LOADER_SET,
  state
});

export const notifySet = (state) => ({
  type: NOTIFY_SET,
  state
});

export const userSet = (state) => ({
  type: USER_SET,
  state
});
export const tickerSet = (state) => ({
  type: TICKER_SET,
  state
});
export const refreshSet = (state) => ({
  type: REFRESH_SET,
  state
});
export const refreshLoan = (state) => ({
  type: REFRESH_LOAN,
  state
});
export const refreshBorrow = (state) => ({
  type: REFRESH_BORROW,
  state
});
export const refreshSecMaster = (state) => ({
  type: REFRESH_SECMASTER,
  state
});

export const refreshCpty = (state) => ({
  type: REFRESH_CPTY,
  state
});
export const setCptyData = (state) => (
  {
  type: CPTY_SET,
  state
});




